export default __webpack_public_path__ + "../staticImages/delivery-type-hermes.png";